<script setup lang="ts">

import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    buttonStyle?: 'primary' | 'secondary'
    isDisabled?: boolean
  }>(),
  {
    buttonStyle: 'primary',
    isDisabled: false
  }
)

const buttonClasses = computed(() => {
  let classes = 'font-medium py-2 px-4 rounded-lg shadow-xl transition duration-300 ease-in-out transform hover:scale-[1.02]'

  if (props.buttonStyle === 'secondary') {
    classes += ' bg-gray-600 hover:bg-grey-700 text-white'
  } else { // 'primary'
    classes += ' bg-signature-blue hover:hover-signature-blue text-white'
  }
  const stateClasses = {
    'opacity-50': props.isDisabled,
    'shadow-lg': !props.isDisabled
  };
  return [classes, stateClasses];
})


</script>

<template>
  <button :class="buttonClasses">
    <slot></slot>
  </button>
</template>
